module.exports = {"title":"About me","layout":"page","path":"/about","body":"<p>東京に住んでいる国立大学生で現在留年中です。<br>\nweb, iOS開発をしながら自然言語処理の勉強をしています。</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./pages/about/index.md
// module id = 523
// module chunks = 0